// TODO enable eslint
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import PropTypes from "prop-types"
import React, { Component } from "react"

import { iterateTimes } from "../utility/calendar"

export default class Columns extends Component {
  static propTypes = {
    canvasTimeStart: PropTypes.number.isRequired,
    canvasTimeEnd: PropTypes.number.isRequired,
    canvasWidth: PropTypes.number.isRequired,
    lineCount: PropTypes.number.isRequired,
    minUnit: PropTypes.string.isRequired,
    timeSteps: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    verticalLineClassNamesForTime: PropTypes.func,
    planStart: PropTypes.number,
    planEnd: PropTypes.number,
  }

  shouldComponentUpdate(nextProps) {
    return !(
      (nextProps.canvasTimeStart === this.props.canvasTimeStart &&
        nextProps.canvasTimeEnd === this.props.canvasTimeEnd &&
        nextProps.canvasWidth === this.props.canvasWidth &&
        nextProps.lineCount === this.props.lineCount &&
        nextProps.minUnit === this.props.minUnit &&
        nextProps.timeSteps === this.props.timeSteps &&
        nextProps.height === this.props.height &&
        nextProps.verticalLineClassNamesForTime ===
          this.props.verticalLineClassNamesForTime) ||
      nextProps.planStart !== this.props.planStart ||
      nextProps.planEnd !== this.props.planEnd
    )
  }

  render() {
    const {
      canvasTimeStart,
      canvasTimeEnd,
      canvasWidth,
      minUnit,
      timeSteps,
      height,
      verticalLineClassNamesForTime,
      planStart,
      planEnd,
    } = this.props
    const ratio = canvasWidth / (canvasTimeEnd - canvasTimeStart)

    const lines = []

    iterateTimes(
      canvasTimeStart,
      canvasTimeEnd,
      minUnit,
      timeSteps,
      (time, nextTime) => {
        const left = (time.valueOf() - canvasTimeStart) * ratio
        const minUnitValue = time.get(minUnit === `day` ? `date` : minUnit)
        const firstOfType = minUnitValue === (minUnit === `day` ? 1 : 0)
        const labelWidth = (nextTime.valueOf() - time.valueOf()) * ratio

        let classNamesForTime = [` `]
        if (verticalLineClassNamesForTime) {
          classNamesForTime = verticalLineClassNamesForTime(
            time.unix() * 1000, // turn into ms, which is what verticalLineClassNamesForTime expects
            nextTime.unix() * 1000 - 1,
          )
        }
        if (nextTime <= planStart || time >= planEnd) {
          classNamesForTime.push(`rct-out-of-plan`)
        }

        // TODO: rename or remove class that has reference to vertical-line
        const classNames = `rct-vl${firstOfType ? ` rct-vl-first` : ``}${
          minUnit === `day` || minUnit === `hour` || minUnit === `minute`
            ? ` rct-day-${time.day()} `
            : ``
        }${classNamesForTime.join(` `)}`

        lines.push(
          <div
            key={`line-${time.valueOf()}`}
            className={classNames}
            style={{
              pointerEvents: `none`,
              top: `0px`,
              left: `${left}px`,
              width: `${labelWidth + 1}px`,
              height: `${height}px`,
            }}
          />,
        )
      },
    )

    return <div className="rct-vertical-lines">{lines}</div>
  }
}
